<template>
  <div class='nav-container' v-touch:swiperight="swipeRight">
    <!-- header logo -->
    <div class='header-image'>
      <img src='../../static/images/graphics/logo.svg' alt='Bikini Atoll Logo'>
    </div>

    <!-- navigation area -->
    <div class='navigation-links'>

      <!-- map island -->
      <img src='../../static/images/graphics/island.svg' id='island' alt='Island'>
      <img src='../../static/images/graphics/pacific-ocean.svg' id='map-label' alt='Ocean Label'>

      <!-- wreckage spots -->
      <div
        v-for='ship, index in ships'
        class='navigation-link'
        :class="{ 'active': index === currentShip }"
        @click='navClick(index)'
      >
        <div class='plus'>
          <div class="sonar"></div>
          <div class="plus-background"></div>
          <img src='../../static/images/graphics/plus.svg' alt='Plus Symbol'>
        </div>
        <p>
          {{ship.name}}
          <span class='ship-location'>
            LAT: {{ship.latitude}},
            <br>
            LNG: {{ship.longitude}}
          </span>
        </p>
      </div>
    </div>
    <div class='scale-info'>
      <p>*map not to scale</p>
    </div>
  </div>
</template>

<script>
  import ships from '@/ships';
  import { mapMutations, mapGetters } from 'vuex';

  const sonarMp3 = require('@/../static/audio/sonar.mp3');
  const sonarOgg = require('@/../static/audio/sonar.ogg');

  export default {
    name: 'navigation',
    data() {
      return {
        ships,
      };
    },
    computed: {
      ...mapGetters('ships', ['currentShip']),
      ...mapGetters('audio', ['muteAudio']),
    },
    mounted() {
      // sonar bleep
      this.sonar = new Audio();
      if (this.sonar.canPlayType('audio/mpeg')) {
        this.sonar.src = sonarMp3;
      } else {
        this.sonar.src = sonarOgg;
      }

      this.sonar.volume = 0.3;
      this.sonar.muted = this.muteAudio;
    },
    beforeDestroy() {
      this.sonar.pause();
    },
    methods: {
      ...mapMutations('ships', ['setCurrentShip']),
      ...mapMutations('ui', [
        'setDrawerState',
        'setMobileState',
      ]),
      ...mapMutations('audio', ['setMuteState']),
      navClick(shipIndex) {
        this.setCurrentShip({ shipIndex });
        this.setDrawerState({ open: true });
        this.playBleep();
      },
      swipeRight() {
        this.setMobileState({ open: false });
      },
      playBleep() {
        this.sonar.pause();
        this.sonar.currentTime = 0;
        this.sonar.play();
      },
    },
    watch: {
      muteAudio() {
        this.sonar.muted = this.muteAudio;
      },
    },
  };
</script>

<style lang="scss">

// mobile
.nav-container {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background-color: rgba(1,2,1,0.85);

  .header-image {
    max-width: 70%;
    margin: 30px auto;
    img {
      width: 100%;
      height: auto;
    }
  }

  .navigation-links {
    width: 100%;
    height: 65%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    max-width: 700px;
  }

  .navigation-link {
    position: absolute;
    width: auto;
    height: 32px;
    border-top: 1px solid #fff;
    padding-left: 10px;
    margin-left: 30px;
    cursor: pointer;
    transform: scale(1);
    transition: transform 200ms;
    p {
      font-size: 8px;
      line-height: 13px;
      color: #fff;
      margin-top: 3px;
      width: auto;
    }
    &:before {
      content: "";
      width: 20px;
      height: 1px;
      display: inline-block;
      background-color: #fff;
      position: absolute;
      top: 8px;
      left: -15px;
      transform: rotate(-60deg);
    }
    .ship-location {
      display: none;
    }

    &:hover, &.active {
      transform: scale(1.1);
      text-shadow: 0px 0px 20px #fff, 0px 0px 20px #fff, 0px 0px 20px #fff;
    }
  }

  .plus {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: -14px;
    transform: scale(1);
    transition: .2s transform ease-out;

    .plus-background {
      width: 12px;
      height: 12px;
      background-color: #7dbf72;
      border-radius: 50%;
      border: 1px solid #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    img {
      width: 8px;
      height: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.navigation-links {
  .navigation-link {
    &:nth-of-type(1) {
      top: 40%;
      left: 62%;
    }
    &:nth-of-type(2) {
      top: 10%;
      left: 25%;
    }
    &:nth-of-type(3) {
      top: 35%;
      left: 40%;
    }
    &:nth-of-type(4) {
      top: 75%;
      left: 62%;
    }
    &:nth-of-type(5) {
      top: 60%;
      left: 30%;
    }
    &:nth-of-type(6) {
      top: 50%;
      left: 48%;
    }
    &:nth-of-type(7) {
      top: 43%;
      left: 22%;
    }
    &:nth-of-type(8) {
      top: 68%;
      left: 46%;
    }
    &:nth-of-type(9) {
      top: 88%;
      left: 46%;
    }
    &:nth-of-type(10) {
      top: 54%;
      left: 16%;
    }
    &:nth-of-type(11) {
      top: 48%;
      left: 0%;
    }
    &:nth-of-type(12) {
      top: 30%;
      left: 22%;
    }
    &:nth-of-type(13) {
      top: 18%;
      left: 50%;
    }

    .sonar {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border: 2px solid #fff;
      opacity: 1;
    }

    &.active {
      .sonar {
        transition: 1.8s all;
        width: 50px;
        height: 50px;
        opacity: 0;
      }
    }
  }
}

#island {
  position: fixed;
  top: 0;
  right: -5%;
  width: 100%;
  max-width: 50%;
  pointer-events: none;
}

#map-label {
  position: absolute;
  pointer-events: none;
  bottom: 10%;
  left: 5%;
  max-width: 100px;
  height: auto;
}

.scale-info {
  position: absolute;
  bottom: 0;
  left: 0;
  p {
    font-size: 14px;
    line-height: 27px;
    color: #fff;
    margin-left: 15px;
  }
}

// tablet portrait and up
@media screen and (min-width: 768px) {
  .navigation-links {
    .navigation-link {
      p {
        font-size: 10px;
        line-height: 13px;
      }
    }
  }
}

// tablet landscape and up
@media screen and (min-width: 992px) {
  .nav-container {
    width: 40%;
    left: 0;
  }
  .navigation-links .navigation-link {
    .ship-location {
      display: none;
    }
  }
}

@media screen and (min-width: 1800px) {
  .navigation-links .navigation-link {
    .ship-location {
      display: block;
    }
  }
}
</style>




// WEBPACK FOOTER //
// Navigation.vue?2876e058